export default __webpack_public_path__ + "static/media/messageSent.b4c29a0d.svg";